import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class ForestWhispering6PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.FOREST_WHISPERING6;
}

export default ForestWhispering6PoiTileEntity;
